import type { RoleType } from '@space-shell/core/store'
import { useViewAsStore } from '@space-shell/core/store'
import clsx from 'clsx'

import { useTranslation } from 'react-i18next'

import { ROLE_TYPES, ROLES } from './constants'

import useDataHubRoleEvents from './useDataHubRoleEvents'

import { useFilterRoles } from './useFilterRoles'
import { useRoleFromLegacyClub } from './useRoleFromLegacyClub'

import { ViewButton } from '../viewButton'

type RoleButtonProps = {
  className?: string
}

const RoleButton = ({ className }: RoleButtonProps) => {
  const { t } = useTranslation()
  const { items } = useFilterRoles()
  const { role, isReadonly } = useViewAsStore()
  const { sendDataHubEventByRole } = useDataHubRoleEvents()

  useRoleFromLegacyClub()

  const handleItemClick = (roleType: RoleType, callback: () => void) => {
    useViewAsStore.setState({ role: roleType })
    callback()

    sendDataHubEventByRole(roleType)
  }

  return (
    <ViewButton
      className={className}
      fieldAction={{
        label: `${t('view_as.profile.field_title')}:`,
        title: t(ROLES[role].title),
        isDisable: isReadonly
      }}
      modal={{
        title: t('view_as.profile.title'),
        description: `${t('view_as.profile.description')}:`
      }}>
      {({ onModalClose }) => {
        return items.map((roleType, index) => {
          const roleItem = ROLES[roleType]
          const isLastItem = index === ROLE_TYPES.length - 1

          return (
            <ViewButton.Item
              key={roleType}
              title={t(roleItem.title)}
              isSelected={role === roleType}
              description={t(roleItem.description)}
              className={clsx({ '_mb-4': !isLastItem })}
              onClick={() => handleItemClick(roleType, onModalClose)}
            />
          )
        })
      }}
    </ViewButton>
  )
}

export default RoleButton
